module.exports = __webpack_public_path__ + "static/media/logo.0a31b7a3.svg";